/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { InvitationImport, InvitationsPage, InviteeResult } from '../../models';
import { ObservableResult } from '../../store';

export const INVITATIONS_DATA_SERVICE = new InjectionToken<InvitationsDataService>('[invitations] invitationsDataService');

/** The playlist or card whose audience is invited. */
export interface InvitedContent {
  id: string;
  isCard: boolean;
}

/** V3 invitations on content whose audience is invited people. Failures carry the API's message, or none. */
export interface InvitationsDataService {
  /** @param page - zero-based */
  list(content: InvitedContent, page: number, size: number): ObservableResult<InvitationsPage>;

  invite(content: InvitedContent, request: { userUids: string[]; emails: string[] }): ObservableResult<InviteeResult[]>;

  /** A CSV with an `email` column, or addresses in the first column. */
  importCsv(content: InvitedContent, file: File): ObservableResult<InvitationImport>;

  /** "Resend" and "Re-invite" alike: for pending, expired and declined invitations. */
  resend(content: InvitedContent, invitationUid: string): ObservableResult<void>;

  /** Only invitations not sent yet. */
  remove(content: InvitedContent, invitationUid: string): ObservableResult<void>;
}
